import { Box, CircularProgress, Stack, StackProps } from '@mui/material';

type LoadingSpinnerType = {
  message?: string;
  ['data-test']?: string;
  iconSize?: number;
};

const LoadingSpinner = ({ message = '', iconSize = 40, ...rest }: LoadingSpinnerType & StackProps) => (
  <Stack {...rest} margin="auto" alignItems="center" justifyItems="center">
    <CircularProgress size={iconSize || 40} />
    <Box data-private>{message}</Box>
  </Stack>
);

export default LoadingSpinner;
